import { paymentConfig } from "../config/paymentConfig";

export const UPSELL_OFFERS = paymentConfig.upsellOffers;
